module.exports = __webpack_public_path__ + "static/media/glassbotpro-logo.ff4a53fd.jpg";